<template>
	<v-layout row wrap>
		<v-flex
			xs12
			:sm6="grid"
			:lg4="grid"
			v-for="category in sortedCategories"
			:key="category.id"
		>
			<v-card :to="category.route_slug" append>
				<v-card-actions class="pa-3">
					<div class="v-icon v-icon--left">
						<fa-icon :icon="['fas', 'folders']" />
					</div>
					<h3 class="subheading">{{ category.name }}</h3>
					<v-spacer></v-spacer>
					<!--					<v-tooltip top>-->
					<!--						<template v-slot:activator="{ on }">-->
					<!--							<v-btn-->
					<!--								icon-->
					<!--								:href="document.full_path"-->
					<!--								target="_blank"-->
					<!--								:download="document.display_name"-->
					<!--								v-on="on"-->
					<!--							>-->
					<!--								<fa-icon icon="download"></fa-icon>-->
					<!--							</v-btn>-->
					<!--						</template>-->
					<!--						<span>Download</span>-->
					<!--					</v-tooltip>-->
				</v-card-actions>
			</v-card>
		</v-flex>

		<v-flex
			xs12
			:sm6="grid"
			:lg4="grid"
			v-for="document in documents"
			:key="document.id"
		>
			<v-card>
				<v-card-actions class="pa-3">
					<div class="v-icon v-icon--left">
						<fa-icon
							:icon="['far', 'file-spreadsheet']"
							v-if="
								document.file_ext === 'XLS' ||
									document.file_ext === 'XLSX'
							"
						/>
						<fa-icon
							:icon="['far', 'file-word']"
							v-else-if="
								document.file_ext === 'DOC' ||
									document.file_ext === 'DOCX'
							"
						/>
						<fa-icon
							:icon="['far', 'file-pdf']"
							v-else-if="document.file_ext === 'PDF'"
						/>
						<fa-icon :icon="['far', 'image']" v-else />
					</div>
					<h3 class="subheading">{{ document.display_name }}</h3>
					<v-spacer></v-spacer>
					<v-tooltip top>
						<template v-slot:activator="{ on }">
							<v-btn
								icon
								:href="`${document.full_path}?download`"
								target="_blank"
								:download="getDownloadName(document)"
								v-on="on"
							>
								<fa-icon icon="download"></fa-icon>
							</v-btn>
						</template>
						<span>Download</span>
					</v-tooltip>
				</v-card-actions>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const { sortCategories } = require("@root/helpers");

export default {
	data() {
		return {
			documents: [],
			categories: []
		};
	},

	props: {
		slug: {
			default: ""
		},
		grid: {
			default: true
		}
	},

	computed: {
		sortedCategories() {
			return sortCategories(this.categories);
		}
	},

	methods: {
		...mapActions("document_center", ["getDocuments", "getCategories"]),

		getDownloadName(document) {
			const { download_name } = document || {};

			if (download_name && !download_name.endsWith(".jpg")) {
				return download_name;
			}
		}
	},

	created() {
		this.getDocuments({
			category: this.slug
		}).then(({ data }) => {
			this.$set(this, "documents", data);
		});

		this.getCategories({
			category: this.slug
		}).then(({ data }) => {
			this.$set(this, "categories", data);
		});
	}
};
</script>
